import { Children } from 'react';
import styles from "./BulletList.module.scss";

//TODO - change to ol/li semanatics
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BulletList(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.root,
    children: Children.map(children, (child, i) => /*#__PURE__*/_jsxs("div", {
      className: styles.bulletRow,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.bullet,
        children: i + 1
      }), /*#__PURE__*/_jsx("span", {
        children: child
      })]
    }, i))
  });
}